import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteWhatsappReportUploadAction,
  getAppoinmentAction,
  getWhatsappAppoinmentReportUploadAction,
  whatsappReportUploadFileAction,
  updateAppoinmentStatusAction,
  updateWhatsappAppoinmentStatusAction,
  getWhatsappAppointmentActions,
} from "../../../redux/actions/AppoinmentAction";
import moment from "moment";
import { getDispatch } from "../../../Utils/helper";
import { IS_SHOW_POPUP } from "../../../Utils/types";

export const WhatsappUploadReportPopup = ({
  isUploadReportPopup,
  setIsUploadReportPopup,
  params,
  searchFilter,
  apiParams,
}) => {
  const dispatch = useDispatch();

  const getWhatsappAppoinmentUploadReport = useSelector(
    (state) => state?.AppoinmentReducer?.getWhatsappAppoinmentUploadReport
  );
  const globalReducer = useSelector((state) => state?.globalReducer);

  useEffect(() => {
    dispatch(
      getWhatsappAppoinmentReportUploadAction(
        params?.token,
        isUploadReportPopup?.cardDetails?.valueType,
        isUploadReportPopup?.cardDetails?.appointmentId
      )
    );
  }, []);

  const handleFileChange = async (e) => {
    const formData = new FormData();
    Object.values(e.target.files)?.map((ele) => {
      return formData.append("Attachments", ele);
    });
    formData.append(
      "AppointmentId",
      isUploadReportPopup?.cardDetails?.appointmentId
    );
    formData.append("DCConfirmationFlag", "U");
    // formData.append("Source", params?.source);
    await dispatch(
      whatsappReportUploadFileAction(
        params,
        formData,
        isUploadReportPopup?.cardDetails?.valueType,
        dispatch
      )
    );
    await dispatch(
      getWhatsappAppoinmentReportUploadAction(
        params?.token,
        isUploadReportPopup?.cardDetails?.valueType,
        isUploadReportPopup?.cardDetails?.appointmentId
      )
    );
  };

  const handleClose = () => {
    setIsUploadReportPopup(null);
    getDispatch(IS_SHOW_POPUP, false, dispatch);
  };

  return (
    <>
      <div className="d-flex justify-content-between  border-bottom modalHeader">
        <h4 className="font-bold text-black">Uploaded Reports</h4>
        <button
          type="button"
          className="btn-close history-close"
          onClick={handleClose}
        ></button>
      </div>
      <div className="modal-body">
        <div className="table-responsive __custom__properties">
          {isUploadReportPopup?.isUploadReport && (
            <label>
              <input
                type="file"
                id="imageUpload"
                style={{ width: "2px" }}
                onChange={(e) => handleFileChange(e)}
                multiple
              />
              <span
                className="d-flex align-items-center gap-10"
                style={{ cursor: "pointer" }}
              >
                <p className="upload-file-p" style={{ color: "#5157a0" }}>
                  Select a file to upload
                </p>
                <i className="fa fa-upload" style={{ color: "#5157a0" }}></i>
              </span>
            </label>
          )}
          <table className="table mt-3">
            <thead>
              <tr className="table-upload-tr">
                <th scope="col">Report Name</th>
                <th scope="col" className="text-center">
                  View
                </th>
                {isUploadReportPopup?.isUploadReport && (
                  <th scope="col" className="text-center">
                    Remove
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {getWhatsappAppoinmentUploadReport?.results?.length ? (
                getWhatsappAppoinmentUploadReport?.results?.map(
                  (ele, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <span
                            className="status-style"
                            style={{
                              textTransform: "capitalize",
                              fontWeight: "500",
                            }}
                          >
                            {ele?.fileName}
                          </span>
                        </td>
                        <td className="text-center">
                          <a
                            href={ele?.filePath}
                            style={{ color: "black" }}
                            target="blank"
                          >
                            <i className="fa fa-eye"></i>
                          </a>
                        </td>
                        {isUploadReportPopup?.isUploadReport && (
                          <td className="text-center">
                            <img
                              type="button"
                              src="../.https://live.healthassure.in/ProvidersPortal/images/removeicon.png"
                              style={{ cursor: "pointer" }}
                              onClick={async () => {
                                await dispatch(
                                  deleteWhatsappReportUploadAction(params, {
                                    docId: ele?.docId,
                                    valueType:
                                      isUploadReportPopup?.cardDetails
                                        ?.valueType,
                                    appointmnetId:
                                      isUploadReportPopup?.cardDetails
                                        ?.appointmentId,
                                  })
                                );
                                dispatch(
                                  getWhatsappAppoinmentReportUploadAction(
                                    params?.token,
                                    isUploadReportPopup?.cardDetails?.valueType,
                                    isUploadReportPopup?.cardDetails
                                      ?.appointmentId
                                  )
                                );
                              }}
                              alt=""
                            />
                          </td>
                        )}
                      </tr>
                    );
                  }
                )
              ) : (
                <p className="no-record-p">No Record Found</p>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {isUploadReportPopup?.isUploadReport && (
        <div
          className="modal-footer"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "nowrap",
            gap: "20px",
          }}
        >
          <div>
            {getWhatsappAppoinmentUploadReport?.message && (
              <>
                <b>Remarks:</b> {getWhatsappAppoinmentUploadReport?.message}
              </>
            )}
          </div>
          <div className="d-flex">
            <button
              type="button"
              className="btn btn-close-upload"
              onClick={handleClose}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-upload-upload"
              onClick={async () => {
                await dispatch(
                  updateWhatsappAppoinmentStatusAction(
                    {
                      appointmentId:
                        isUploadReportPopup?.cardDetails?.appointmentId,
                      dcConfirmationFlag: "U",
                      appointmentDate:
                        isUploadReportPopup?.cardDetails?.appointmentDateTime,
                      timeSlot: moment(
                        isUploadReportPopup?.cardDetails?.appointmentDateTime
                      ).format("YYYY-MM-DD hh:mm A"),
                      appointmentStatusId:
                        isUploadReportPopup?.cardDetails?.appointmentstatusid,
                      validate: false,
                      remarkId: 0,
                      valueType: isUploadReportPopup?.cardDetails?.valueType,
                    },
                    params
                  )
                );
                await dispatch(
                  getWhatsappAppointmentActions(
                    {
                      page: globalReducer?.getCurrentPage,
                      rows: 10,
                    },
                    params
                  )
                );
                await handleClose();
              }}
              disabled={
                getWhatsappAppoinmentUploadReport?.results?.length === 0
              }
              style={{ width: "90px", marginLeft: "10px" }}
            >
              Submit
            </button>
          </div>
        </div>
      )}
    </>
  );
};
